module.exports = __webpack_public_path__ + "img/type3-3.c87afd63.png";